import React from 'react'
import DonationAccordion from '../components/DonationAccordion '
import PageHeader from '../components/PageHeader';

const DonationDetails = () => {
  return (
    <>
   <PageHeader title="देणगी तपशील" path="/donation-details" name="donate" />
   <DonationAccordion/>
   </>
  )
}

export default DonationDetails